import { hotjar } from "react-hotjar";

const initializedGuard = (): void => {
  if (!hotjar.initialized()) {
    hotjar.initialize(3323967, 6);
  }
};

const safeHotjar: Omit<typeof hotjar, "initialized" | "initialize"> = {
  identify: (userId: string | null, properties: Record<string, any>): void => {
    initializedGuard();
    hotjar.identify(userId, properties);
  },
  event: (event: string): void => {
    initializedGuard();
    hotjar.event(event);
  },
  stateChange: (relativePath: string): void => {
    initializedGuard();
    hotjar.stateChange(relativePath);
  },
};

export { safeHotjar as hotjar };
